import { render, staticRenderFns } from "./MessagesDropdown.vue?vue&type=template&id=37d26afc&"
import script from "./MessagesDropdown.vue?vue&type=script&lang=js&"
export * from "./MessagesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MessagesDropdown.vue?vue&type=style&index=0&id=37d26afc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports